<template>
    <div class="base-title">
        <div class="p-lg-4 p-0 pt-4">
            <div class="align justify-content-end">
                <div class="title item flex-grow-1">
                    <h2>
                        <font-awesome-icon v-if="redirectBack"  @click="goBack" class="icon back_arrow" icon="fas fa-arrow-left"/>
                        <font-awesome-icon v-else-if="props.title.icon" class="icon" :icon="'fas ' + props.title.icon" />
                        <span v-if="redirectBack" class="back_arrow_title">
                            {{ props.title.title}}
                            <slot name="title"></slot>
                        </span>
                        <span v-else>
                            {{ props.title.title}}
                            <slot name="title"></slot>
                        </span>
                    </h2>
                </div>
                <slot></slot>
            </div>
        </div>
    </div>
    <div class="space-base-title"></div>
</template>

<script setup>
import { ref, onBeforeMount, onMounted, onBeforeUnmount } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

const props = defineProps({
    title: {
        required: true,
        default: null
    },

    removeSearchBar: {
        type: Boolean,
        required: false,
        default: false,
    },

    initialSearch: {
        required: false,
        default: null
    },

    redirectBack: {
        required: false,
        default: null,
    },
});

function createBorderOnScroll() {
    let body = document.querySelector("body");
    if(window.scrollY != 0){
        body.classList.add('scrolling');
    }else {
        body.classList.remove('scrolling');
    }
}

function goBack(){
    router.push(props.redirectBack)
}

const search = ref(null);

onBeforeMount(() => {
    if(props.initialSearch != null) {
        search.value = props.initialSearch;
    }
});

onMounted(() => {
    window.addEventListener("scroll", createBorderOnScroll, true);
});

onBeforeUnmount(() => {
    window.removeEventListener("scroll", createBorderOnScroll, true);
});
</script>

<style>
.space-base-title {
    height: 77px;
}

.base-title {
    position: fixed;
    top: 60px;
    z-index: 99;
    border-bottom: 0;
    left: 0;
    width: 100%;
    padding-left: 255px;
    background: #f7f7f7;
}

.base-title .align {
    display: flex;
    align-items: center;
    min-height: 38px;
    max-width: 1150px;
    margin: 0 auto;
}

.base-title .space-between {
    justify-content: space-between;
}

.base-title .item {
    flex: 1;
    margin-left: 20px;
}

.base-title .title {
    flex: inherit;
    margin-left: 0px;
}

.base-title h2 {
    display: inline-block;
    font-size: 18px;
    margin: 0;
    color: #414951;
    font-weight: 500;
}

.base-title h2 .icon {
    margin-right: 10px;
    color:#28bc6d;
}

.base-title .action {
    min-width: 100px;
    flex: 0 0 120px;
    margin-left: 10px;
    justify-content: end;
}

.base-title .badget {
    position: relative;
    top: -2px;
    margin-left: 10px;
}

body.scrolling .base-title {
    border-bottom: 1px solid #d7d7d7;
}

.back_arrow{
    cursor: pointer;
    border-radius: 50%;
    padding: 7px 8px;
}

.back_arrow:hover{
    box-shadow: inset 0px 0px 50px rgb(0 0 0 / 20%);
}

.back_arrow_title{
    position: relative;
    top: -7px;
}

.search_item {
    max-width: 300px;
}

@media screen and (max-width: 992px){

    .base-title{
        position: relative;
        padding-left: 0px;
        text-align: center;
        padding-bottom: 1rem;
        border-bottom: 0px !important;
        top: 0;
    }

    .base-title .align{
        display: block;
    }

    .base-title .action{
        flex: none;
    }

    .base-title .item, .base-title .btn-group{
        width: 100%;
        margin: 8px 0px;
    }

    .space-base-title {
        display: none;
    }

}
</style>